import { makeStyles } from "@material-ui/core/styles";
import { rv } from "../../tokens";
import { LockIcon } from "../icons";
import { useFieldStyles } from "./fieldStyles";

const useStyles = makeStyles({
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    minHeight: 46,
    background: rv.lockedFill,
    border: `1.5px solid ${rv.hairline}`,
    borderRadius: rv.radiusInput,
    padding: "0 14px",
    color: "#5A5A5A",
    fontSize: 14,
    fontFamily: rv.fontSans,
  },
  value: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

interface Props {
  label?: string;
  value: string | number | undefined | null;
}

// Read-only, never-editable field (e.g. email, or Tier 2 out-of-scope identity
// fields). The owning SectionCard shows the green "Verified" pill.
export default function LockedField({ label, value }: Props) {
  const classes = useStyles();
  const field = useFieldStyles();
  const display =
    value === null || value === undefined || value === "" ? "\u2014" : String(value);
  return (
    <div className={field.root}>
      {label && <label className={field.label}>{label}</label>}
      <div className={classes.box}>
        <span className={classes.value}>{display}</span>
        <LockIcon size={15} color={rv.muted3} />
      </div>
    </div>
  );
}
